import draw from "./withcoronaDraw-jp";

draw();
